import { formatDate } from "date-fns";

import MDTypography from "@/components/atoms/MDTypography";
import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import { formatCurrency } from "@/helpers/currency-helpers";
import { Transaction } from "@/interfaces/talk2pay.iterfaces";

interface Props {
  index: number;
  transation: Transaction;
}

export function StatementTableRow({ index, transation }: Props) {
  return (
    <TableRow index={index}>
      {/* TODO: fix this */}
      <TableCell>
        <MDTypography variant="button">{formatDate(transation.date, "dd/MM/yyyy")}</MDTypography>
      </TableCell>
      <TableCell>
        <MDTypography variant="button">{transation.id}</MDTypography>
      </TableCell>
      <TableCell>
        <MDTypography variant="button">{transation.description}</MDTypography>
      </TableCell>
      <TableCell align="right">
        <MDTypography variant="button" color={transation.value >= 0 ? "info" : "error"}>
          {formatCurrency(transation.value)}
        </MDTypography>
      </TableCell>
      <TableCell align="right">
        <MDTypography variant="button">{formatCurrency(transation.balance)}</MDTypography>
      </TableCell>
    </TableRow>
  );
}
